import { useStore } from '../store';
import { SubmitPayloadModal } from './SubmitPayloadModal';

// Mounted once in the shell so "Submit to library" works from the menu and
// the palette regardless of whether the payload drawer is open.
export function SubmitModalHost() {
  const open = useStore((s) => s.submitOpen);
  const setOpen = useStore((s) => s.setSubmitOpen);
  if (!open) return null;
  return (
    <SubmitPayloadModal
      onClose={() => setOpen(false)}
      onSubmitted={() => {
        setOpen(false);
        window.dispatchEvent(new Event('xsscool:payloads-changed'));
      }}
    />
  );
}
